import PropTypes from 'prop-types';
import { Icon } from '@icp/components';
import { useTranslation } from 'react-i18next';
import ConditionLine from './ConditionLine';
import { useReadonly } from '../NodeContextProvider';

function SettingCondition(props) {
  const { data, onChange } = props;

  const readonly = useReadonly();
  const { t } = useTranslation(['icp-form-renderer']);

  const { operator } = data;
  const conditions = data.conditions?.length ? data.conditions : [{}];

  const handleAddCondition = (newOperator) => {
    const newConditions = [...conditions, {}];

    const newData = {
      ...data,
      operator: newOperator,
      conditions: newConditions,
    };

    onChange(newData);
  };

  const handleChange = (index, newConditionData) => {
    const newConditions = [...conditions];
    newConditions[index] = newConditionData;

    const newData = {
      ...data,
      conditions: newConditions,
    };

    onChange(newData);
  };

  const handleDelete = (index) => {
    const newConditions = [...conditions];
    newConditions.splice(index, 1);

    const newData = {
      ...data,
      operator: newConditions.length <= 1 ? undefined : operator,
      conditions: newConditions,
    };

    onChange(newData);
  };

  const handleOperatorChange = (newOperator) => {
    onChange({
      ...data,
      operator: newOperator,
    });
  };

  const handleAddConditionClick = () => {
    handleAddCondition(operator || 'AND');
  };

  return (
    <>
      <div className="icp-workflow-condition-group">
        {(conditions || []).map((item, index) => {
          return (
            <ConditionLine
              key={item.id || index}
              index={index}
              operator={operator}
              deleteAble={conditions.length > 1}
              data={item}
              onDataChange={(newConditionData) => handleChange(index, newConditionData)}
              onDelete={() => handleDelete(index)}
              onOperatorChange={handleOperatorChange}
            />
          );
        })}
      </div>
      {!readonly ? (
        <button className="icp-action-button" onClick={handleAddConditionClick}>
          <Icon name="oct:plus" size={16} />
          {t('workflow.condition.add')}
        </button>
      ) : null}
    </>
  );
}

SettingCondition.propTypes = {
  data: PropTypes.shape({
    operator: PropTypes.oneOf(['AND', 'OR']),
    conditions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  onChange: PropTypes.func,
};

export default SettingCondition;
